<script setup lang="ts">
useHead({
  meta: [
    {
      name: 'description',
      content: 'Miss W - Your Voice, Your Vote, Your Victory',
    },
  ],
})
</script>

<template>
  <div w-full overflow-x-hidden>
    <MissWHeader
      cover="/images/image-167-vote.webp"
      title="vote"
      subtitle="YOUR VOICE, YOUR VOTE, YOUR VICTORY"
      intro="Each vote brings your ambassador closer to the crown and further cements the role of blockchain in the global beauty movement. Ready to make history? Stake, buy, vote, and let the best ambassador win!"
      mask="linear-gradient(180deg, rgba(87, 0, 0, 0.77) 0%, rgba(102, 0, 0, 0.00) 13.56%, rgba(95, 0, 0, 0.00) 63.07%, rgba(94, 0, 0, 0.60) 79.45%, #5E0000 100%)"
    />

    <div class="test" w-full pt-80px>
      <VoteSection1 />

      <VoteSection2 mt-100px />

      <VoteSection3 mt-100px />

      <VoteSection4 mt-40px lg:mt-230px />
    </div>

    <IntroductionSponsors pt-60px>
      <div container mb-80px text-center lg:mb-200px>
        <p text-24px font-bold uppercase>
          YOUR VOTE WILL DETERMINE THEIR DESTINY
        </p>

        <p class="lh-100%" py-20px text-53px font-bold uppercase lg:text-120px>
          VOTE <span class="text-#CE0000">NOW</span>
        </p>
        <p class="text-#CE0000">
          Crypto Wallet with 1499 BTC will be shown during Event Day.
        </p>

        <a href="https://missweb3.app" target="_blank" mt-40px btn-primary inline-block uppercase class="w-295px p-[20px_25px]">
          VOTE NOW
        </a>
      </div>
    </IntroductionSponsors>
  </div>
</template>

<style scoped>
.test {
  background: linear-gradient(
    180deg,
    #5e0000 0%,
    #000 9.62%,
    #000 63.94%,
    #80000e 100%
  );
}
</style>
